import { createFileRoute } from '@tanstack/react-router'
import { ImportPageClient } from '#/components/import/ImportPageClient'

export const Route = createFileRoute('/_authenticated/$slug/settings/import')({
  component: ImportPageClient,
})
